import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import Weather from '../../../components/Weather/Weather';

export function WeatherMap({ field, index, userId }) {
  return <Weather field={field} index={index} userId={userId} />;
}

WeatherMap.propTypes = {
  field: PropTypes.object,
  index: PropTypes.number,
  userId: PropTypes.number,
};

function mapStateToProps(state) {
  return {
    field: state.field,
    userId: state.user.id,
  };
}

export default connect(mapStateToProps)(WeatherMap);
